import PropTypes from 'prop-types';

const Contact = {
  id: PropTypes.number,
  zoneId: PropTypes.string,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  email: PropTypes.string,
};

export const ContactShape = PropTypes.shape(Contact);
export const ContactExact = PropTypes.exact(Contact);
